export default __webpack_public_path__ + "static/media/avatar.243091a7.svg";